module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CheckoutContainer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active == true),
      expression: "is_active == true"
    }],
    staticClass: "LinkContainer"
  }, [_c('a', {
    attrs: {
      "href": '#/checkout/' + _vm.module_id
    }
  }, [_c('button', {
    staticClass: "btn btn-default checkout"
  }, [_vm._v(_vm._s(_vm.$t('product.cta_checkoutpage')))])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active == false),
      expression: "is_active == false"
    }]
  }, [_vm._v(_vm._s(_vm.$t('cart.warning_empty')))]), _vm._v(" "), _c('div', {
    staticClass: "CtaList"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'List',
          params: {
            module_id: _vm.active_module.module_id,
            scrollParent: true
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cart.cta_goback')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03caad4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/_partials/go-checkout.vue
// module id = 241
// module chunks = 1